import { createFileRoute } from "@tanstack/react-router"
import { GovernanceElectionsPage } from "@/pages"
import { AuthorizationGate } from "@/components"
import { Resource, Action } from "@mimber/schema"

export const Route = createFileRoute(
  "/_authenticated/_organization/governance/elections"
)({
  component: () => (
    <AuthorizationGate resource={Resource.GOVERNANCE} action={Action.READ}>
      <GovernanceElectionsPage />
    </AuthorizationGate>
  ),
})
